export const mutations = {
  STORE_PRODUCTS(state, products) {
    state.products = products;
  },

  STORE_PRODUCT(state, singleproducts) {
    state.singleproducts = singleproducts;
  },
  STORE_PRODUCT_STAT(state, statproductsales) {
    state.statproductsales = statproductsales;
  },
  STORE_PRODUCT_TOTAL_SALES(state, total) {
    state.total = total;
  },
  STORE_PRODUCT_TOTAL_PURCHASE(state, topPurchasedProducts) {
    state.topPurchasedProducts = topPurchasedProducts;
  },
  STORE_PRODUCT_TOTAL_SALE(state, topSoldProducts) {
    state.topSoldProducts = topSoldProducts;
  },

  STORE_DEFECTIVE_PRODUCT(state, deadproducts) {
    state.deadproducts = deadproducts;
  },


  STORE_PRODUCT_UPDATE(state, productId) {
    let Product = state.products.find(function(product) {
      return product.id === productId;
    });
    state.systemProduct = Product;
  },
  STORE_PROD_NO(state, prod_no) {
    state.prod_no = prod_no;
  },
  STORE_SELLING_PRICE(state, sellprice){
    state.sellprice = sellprice;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/mutations.js